<template>
    <section>
        <div
            :class="`results products grid --${resultsLayout}`"
        >
            <div>
                <ais-stats v-slot="{ nbHits, query }">
                    <results-filter
                        v-if="nbHits"
                        @changeLayout="layout => resultsLayout = layout"
                        :sortIndexes="sortIndexes"
                    ></results-filter>
                    <div v-else></div>
                </ais-stats>

                <ais-hits>
                    <template #item="{ item }">
                        <div v-if="item.detailImage">
                            <a :href="item.uri" class="product-img">
                                <img :src="item.detailImage" :alt="item.title">
                            </a>
                        </div>

                        <!-- <a :href="item.uri" v-text="item.title"></a> -->
                        <div class="figure" v-text="item.figureNumber"></div>
                        <p class="title">
                            <a :href="item.uri" v-text="item.title"></a>
                        </p>

                        <div class="data">
                            <div class="download">
                                <a v-if="item.downloadUrl" :href="item.downloadUrl" target="_blank">
                                    Download
                                    <svg class="icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 10.9 13" style="enable-background:new 0 0 10.9 13;" xml:space="preserve">

                                    <path  d="M10,11.3c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7H0.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7H10z
                                        M8.4,5.2c0.2-0.3,0.7-0.3,0.9,0c0.3,0.2,0.3,0.7,0,0.9L5.9,9.8c-0.2,0.3-0.7,0.3-1,0L1.4,6.1c-0.2-0.3-0.2-0.7,0-0.9
                                        C1.6,5.1,1.8,5,1.9,5s0.3,0.1,0.5,0.2l2.4,2.5V1.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v6.6L8.4,5.2z"/>
                                    </svg>
                                </a>
                            </div>
                            <modal :result="item" :user="user"></modal>
                        </div>
                    </template>
                </ais-hits>


                <ais-stats v-slot="{ nbHits, query }">
                    <ais-pagination v-if="nbHits" />
                    <div v-else class="container">
                        <p class="info" v-if="isBrand">
                            Products for this brand are not yet available.
                        </p>
                        <div v-else>
                            <no-results :query="query" />
                        </div>
                    </div>
                </ais-stats>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';
    import ProductModal from 'vue/products/_modal';
    import Results from  'vue/common/_results';
    import Utility from 'Utility';

    export default {
        components: {
            'modal': ProductModal
        },
        computed: {
            isBrand(){
                let path = window.location.pathname;
                return path.indexOf('brand') > -1;
            },
        },
        data: () => ({
            resultsLayout: 'grid',
        }),
        props: ['user', 'sortIndexes'],
        methods: {
            ...mapGetters('productStore', ['isProductRoot']),
            ...mapActions('mechanical', ['getListOfSubmittals']),
        },

        mounted() {
            if (this.user) {
                 this
                .getListOfSubmittals()
                .then(response => {
                    this.projects = response;
                });
            }
        }
    }
</script>
